import { AfterViewInit, Component, ElementRef, HostBinding, Injector, ViewChild } from '@angular/core';
import { MenuAsideOffcanvasDirective } from 'src/assets/lib/metronic/app/core/directives/menu-aside-offcanvas.directive';
import { LayoutRefService } from 'src/assets/lib/metronic/app/core/services/layout-ref.service';
import { appModuleAnimation } from 'src/shared/animations/routerTransition';
import { AppComponentBase } from 'src/shared/common/app-component-base';

@Component({
  standalone: false,
  templateUrl: './default-layout.component.html',
  selector: 'default-layout',
  animations: [appModuleAnimation()],
})
export class DefaultLayoutComponent extends AppComponentBase implements AfterViewInit {
  @ViewChild('mHeader', { static: true }) mHeader: ElementRef;
  @ViewChild('mAsideLeft', { static: true }) mAsideLeft: ElementRef;
  @HostBinding('attr.mMenuAsideOffcanvas') mMenuAsideOffcanvas: MenuAsideOffcanvasDirective;

  constructor(
    injector: Injector,
    private layoutRefService: LayoutRefService,
  ) {
    super(injector);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.mMenuAsideOffcanvas = new MenuAsideOffcanvasDirective(this.mAsideLeft);
      this.mMenuAsideOffcanvas.ngAfterViewInit();
    });

    this.layoutRefService.addElement('header', this.mHeader.nativeElement);

    this.registerToEvents();
  }

  registerToEvents() {
    eaf.event.on('app.router.navigationEnd', () => {
      this.mMenuAsideOffcanvas.menuOffcanvas.hide();
    });
  }
}
